module.exports = __webpack_public_path__ + "media/styles/images/svg/circle-ex-white-76bf9424adb9469465b92b52bcfbdc7e.svg";